class SponsoredBy {
	init() {
		const sponsoredItems = Array.from(document.querySelectorAll<HTMLElement>("aside.sponsored-by"));

		sponsoredItems.forEach(sponsoredItem => {
			const closeButtons = Array.from(sponsoredItem.querySelectorAll(".btn-close"));

			closeButtons.forEach(closeButton => {
				closeButton.addEventListener("click", event => {
					sponsoredItem.classList.remove("open");
					event.preventDefault();
					event.stopPropagation();
				});
			});

			sponsoredItem.addEventListener("click", event => {
				sponsoredItem.classList.add("open");
				event.preventDefault();
				event.stopPropagation();
			});
		});

		document.addEventListener("click", event => {
			sponsoredItems.filter(sponsoredItem => sponsoredItem.classList.contains("open")).forEach(sponsoredItem => {
				const rect = sponsoredItem.getBoundingClientRect();
				const isInContent = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height
					&& rect.left <= event.clientX && event.clientX <= rect.left + rect.width);

				if (!isInContent) {
					sponsoredItem.classList.remove("open");
				}
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const sponsoredBy = new SponsoredBy();
	sponsoredBy.init();
});
